import React from 'react';
import FeatureCard from 'components/FeatureCard';
import { Col } from 'react-bootstrap';
import { toast } from 'react-toastify';

export const listFeatures = (data, featureBaseUrl) => {
  return data.map((feature_data, idx) => {
    const d = feature_data.data;
    return (
      <Col xs="12" md="6" lg="3" key={idx} className="mb-3">
        <FeatureCard
          title={d.Feature_Name}
          description={d.List_Page_Snippet}
          featurePrice={d.Cost}
          CTALink={`${featureBaseUrl}/${feature_data.fields.slug}/`}
          iconVariant={
            d.Icon_To_Use === 'react-icons'
              ? `ri:${d.React_Icon}`
              : d.Icon_To_Use === 'local'
              ? `local:${d.Local_Icon}`
              : false
          }
          isIconInline={true}
          isIconFill={d.Icon_Fill}
        />
      </Col>
    );
  });
};

export const handleResponesWithToastify = data => {
  /* 
    This method accept response from django custom ApiRenderer 

    data={'data': data, 'success': True, 'message': 'Successfully Registered'}, status=200)
  */
  if (data) {
    if (data.success) {
      toast.success(data.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      toast.error(data.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
};
